import Vue, { PluginObject } from 'vue';
import { Store } from 'vuex';
import { getStore } from '@/store';

type SnackbarContent = {
    message: string;
    color?: string;
    timeout?: number;
};
type ToastPlugin = (content: SnackbarContent) => void;

// extend ComponentOptions so that we can use Vue({toast:toast}) in main:
declare module 'vue/types/options' {
    interface ComponentOptions<V extends Vue> {
        toast?: PluginObject<{ store: Store<any> }>;
    }
}
declare module 'vue/types/vue' {
    interface Vue {
        $toast: ToastPlugin;
    }
    interface VueConstructor {
        $toast: ToastPlugin;
    }
}

export default {
    install(V: typeof Vue) {
        V.prototype.$toast = (content: SnackbarContent) => {
            commitToast(content);
        };
    },
};

export function commitToast(content: SnackbarContent) {
    getStore()?.commit('toast', { content });
}
